/* src/app/_shared/components/collapse-button/collapse-button.component.scss */
flw-button {
  --background: #e3e0f9;
}
flw-icon {
  --color: var(--secondary-color);
}
/*# sourceMappingURL=collapse-button.component.css.map */
